import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_75qtacjqim: FaireBrandEntity = {
  token: "b_75qtacjqim",
  type: "brand",
  name: "Cottage Door Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/d152960332127916629363feca8e8b2542696054f027df5b3cd1c20ad15fb20f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/36ee89445b80ede4e1d77a6065b8da36c1c12ee8bb3b6ae43a26d5e9be5a6a3b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d152960332127916629363feca8e8b2542696054f027df5b3cd1c20ad15fb20f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36ee89445b80ede4e1d77a6065b8da36c1c12ee8bb3b6ae43a26d5e9be5a6a3b.png",
  location: "Rolling Meadows, IL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 249,
  isTopShop: true,
  isInsider: true,
  description:
    "We create books that inspire little ones to connect, encourage them to dream, give them cause to celebrate, and allow them to see themselves beautifully reflected in the stories they read. Our content areas focus on key literacies for early childhood including first concepts, animals, social emotional learning, science & nature, religious, seasonal, and multicultural. \n\nOur unique interactive formats, beautiful illustrations, and partnerships with the most exciting and iconic brands in children's entertainment make our books perfect for gift giving or everyday reading.\n\nPlease note: at this time, we only ship to addresses within the United States.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:45.052Z",
    importedBy: "entity-db-cli",
  },
};
